import React from "react";
import './styles.scss';
import DATA from 'utils/data.json';
import Advisers from "./components/advisers";
import Lecturers from "./components/lecturers";

const TEACHER_DATA = DATA.teacher;

const Teacher = () => {
    
    return (
        <section id='teacher-id' className="teacher-block">
            <p className="title container">{TEACHER_DATA.title}</p>
            <Advisers />
            <Lecturers />
        </section>
    )
}

export default Teacher